export default __webpack_public_path__ + "static/media/trustErrorImageDark.f7c1612c.svg";